var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMobileGameIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M13.247 0a2.408 2.408 0 0 1 2.408 2.408v10.84a2.408 2.408 0 0 1-2.408 2.407H2.408A2.408 2.408 0 0 1 0 13.247V2.408A2.408 2.408 0 0 1 2.408 0h10.84Zm-3.142 2H5.632a1.681 1.681 0 0 0-1.152.447 1.53 1.53 0 0 0-.347.485 1.414 1.414 0 0 0-.126.592v8.441c0 .21.042.406.126.586.084.18.2.34.347.479a1.681 1.681 0 0 0 1.153.447h4.472a1.681 1.681 0 0 0 1.153-.447c.147-.139.262-.298.346-.479.084-.18.126-.376.126-.586v-8.44c0-.21-.042-.408-.126-.593a1.53 1.53 0 0 0-.346-.485A1.681 1.681 0 0 0 10.105 2Zm-2.243 9.7c.185 0 .34.064.467.19a.633.633 0 0 1 .189.466.64.64 0 0 1-.19.46.623.623 0 0 1-.466.195.63.63 0 0 1-.46-.195.63.63 0 0 1-.195-.46c0-.185.065-.34.196-.466a.64.64 0 0 1 .46-.19Zm2.848-7.57v7.218H5.015V4.129h5.695ZM8.669 2.843c.05 0 .096.019.138.057.042.038.063.09.063.157s-.02.12-.063.158a.203.203 0 0 1-.138.056h-1.6a.203.203 0 0 1-.139-.056.201.201 0 0 1-.063-.158c0-.067.023-.12.07-.157a.213.213 0 0 1 .132-.057Z",
  id: "MobileGameIcon_svg__a"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#3B3B3B",
  xlinkHref: "#MobileGameIcon_svg__a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#757575",
  xlinkHref: "#MobileGameIcon_svg__a"
}))));

export default SvgMobileGameIcon;